import Vue from "vue";
import { VNode } from "vue/types/umd";

import { IModelState, ModelState } from "@elite/validation";

import App from "./App.vue";
import { configure } from "./config";
import { i18n } from "./locale";
import { errorLog } from "./logging";
import router from "./router";
import store, { restClient } from "./store";

Vue.config.productionTip = false;

configure();

const modelState: IModelState = new ModelState();

const provide = { restClient, modelState, errorLog };

new Vue({
    i18n,
    router,
    store,
    provide,
    render: (h): VNode => h(App)
}).$mount("#app");
